import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import axios from 'axios'
import i18n from '../i18n'

interface AuthState {
  accessToken: string | null
  isAuthenticated: boolean
  role: string | null
  plan: string | null
  setAccessToken: (token: string, role: string, plan?: string, language?: string) => void
  login: (email: string, password: string) => Promise<void>
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      isAuthenticated: false,
      role: null,
      plan: null,

      setAccessToken: (token, role, plan, language) => {
        set({ accessToken: token, isAuthenticated: true, role, plan: plan ?? null })
        if (language) {
          i18n.changeLanguage(language)
        }
      },

      login: async (email, password) => {
        const { data } = await axios.post('/api/v1/auth/login', { email, password }, {
          withCredentials: true,
        })
        set({ accessToken: data.access_token, isAuthenticated: true, role: data.role ?? null, plan: data.plan ?? null })
        // Apply user's stored language preference from server
        if (data.language) {
          i18n.changeLanguage(data.language)
        }
      },

      logout: () => {
        axios.post('/api/v1/auth/logout', {}, { withCredentials: true }).catch(() => {})
        set({ accessToken: null, isAuthenticated: false, role: null, plan: null })
      },
    }),
    {
      name: 'oaas-auth',
      partialize: (state) => ({
        accessToken: state.accessToken,
        isAuthenticated: state.isAuthenticated,
        role: state.role,
        plan: state.plan,
      }),
    },
  ),
)
